import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { onAuthError, statusOf } from "@common/api";
import { createQueryClient, useCacheScopedToUser } from "@common/queryClient";
import Banner from "./components/Banner";
import ErrorBoundary from "./components/ErrorBoundary";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { useSession } from "./hooks/useSession";
import AboutPage from "./pages/AboutPage";
import AccountPage from "./pages/AccountPage";
import AdminPage from "./pages/AdminPage";
import HomePage from "./pages/HomePage";

export const queryClient = createQueryClient({ statusOf, subscribeToAuthErrors: onAuthError });

function Shell() {
  const session = useSession();
  useCacheScopedToUser(queryClient, session.user?.sub ?? null);
  const section = useLocation().pathname.split("/")[1];
  return (
    <>
      <Header session={session} />
      <Banner />
      <ErrorBoundary key={section} buttonClassName="btn" primaryButtonClassName="btn primary">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/account" element={<AccountPage session={session} />} />
          <Route path="/admin" element={<AdminPage session={session} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ErrorBoundary>
      <Footer session={session} />
    </>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
